import classNames from 'classnames';
import * as React from 'react';

export interface MetricProps extends React.HTMLAttributes<HTMLDivElement> {
    value: string;
    label: string;
}

export const Metric: React.FunctionComponent<MetricProps> = ({value, label, className, ...rest}: MetricProps) => (
    <div className={classNames('mp-metric', className)} {...rest}>
        <span className="mp-metric__value">{value}</span>
        <span className="mp-metric__label">{label}</span>
    </div>
);
